import './App.css';
import './index.css';
import './components/CartPlugin.css'; // Import all necessary CSS files
import './components/ShopSelector.css';
import './components/CartSummary.css';
import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import ShopSelector from './components/ShopSelector';
import LandingPage from './components/LandingPage';
import CartPlugin from './components/CartPlugin';
import CartSummary from './components/CartSummary';

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<ShopSelector />} />
                <Route path="/cad" element={<LandingPage locale="en_CA" />} />
                <Route path="/usd" element={<LandingPage locale="en_US" />} />
                <Route path="/cart/:sku" element={<CartPlugin />} />
                <Route path="/cart-summary" element={<CartSummary />} />
            </Routes>
        </Router>
    );
};



export default App;
